import { mapActions } from 'vuex';
import { REPORT_SESSION } from "@/store/analytics/actions.type";

const SESSION_MINUTES = 10

export default {
    data() {
        return {
            inactivityTimer: null,
            inactivityTimeout: 60000 * SESSION_MINUTES,
            sessionStarted: false,
        }
    },
    methods: {
        ...mapActions('analytics', [REPORT_SESSION]),
        resetTimer() {
            clearTimeout(this.inactivityTimer);
            if (!this.sessionStarted) {
                const sessionStart = this.$dayjs().toISOString();
                localStorage.setItem('sessionStart', sessionStart);
                this.sessionStarted = true;
            }
            this.inactivityTimer = setTimeout(() => {
                this.reportSession();
            }, this.inactivityTimeout);
        },
        async reportSession() {
            const sessionStart = localStorage.getItem('sessionStart');
            const currentTime = this.$dayjs().toISOString();
            const userId = this.uid.toString();
            const clientId = this.workspace.toString();
            await this.REPORT_SESSION({
                sessionStart,
                currentTime,
                userId,
                clientId
            });
            localStorage.setItem('sessionStart', currentTime);
            this.sessionStarted = false;
        },
        trackUserActivity() {
            this.resetTimer();
        },
        initSessionTracking() {
            if (!localStorage.getItem('sessionStart')) {
                localStorage.setItem('sessionStart', this.$dayjs());
            }
            this.resetTimer();
            window.addEventListener('keydown', this.trackUserActivity);
            window.addEventListener('scroll', this.trackUserActivity);
            window.addEventListener('click', this.trackUserActivity);
        },
        cleanupSessionTracking() {
            clearTimeout(this.inactivityTimer);
            window.removeEventListener('keydown', this.trackUserActivity);
            window.removeEventListener('scroll', this.trackUserActivity);
            window.removeEventListener('click', this.trackUserActivity);
        }
    },
    mounted() {
        this.initSessionTracking();
    },
    beforeDestroy() {
        const isNavigatingToNewPage = this.$route && this.$route.matched.length > 0;
        // if (this.$options.name !== this.$route.name) {
        if (!isNavigatingToNewPage) {
            this.cleanupSessionTracking();
        }
    }
}